import { ArrowBack } from "@mui/icons-material";
import { Create, ListButton, SimpleForm, TextInput, useGetIdentity, useRedirect, useNotify, useRefresh } from "react-admin";
import { TopToolBar } from "../shared-components";

const BackToProfile = ({url}:{url: string}): JSX.Element => {
  return(
    <ListButton to={{pathname: url}}  label={'Go back'} icon={<ArrowBack/>}/>
  )};

export const CreateNote: React.FC = (props: any) =>{
  const notify = useNotify()
  const refresh = useRefresh()
  const redirect = useRedirect()

  const { identity, loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  const noteDefaultValues = () => ({ reference_id: props.location.state.id, type: 'driver', author_type: 'driver_support', author: identity?.email });

  const onSuccess = (record: any) => {
    notify('Changes saved')
    redirect('show', `/notes`, record.data.id, {}, { goBackUrl: props.location?.state?.goBackUrl })
    refresh()
  }
  
  const CreateActions = () => {
    return (
      <TopToolBar left={<BackToProfile url={props.location?.state?.goBackUrl}/>} right={null}/>
    )
  }

  return (
    <Create {...props} mutationMode="pessimistic" onSuccess={onSuccess} actions={<CreateActions {...props}/>}>
      <SimpleForm initialValues={noteDefaultValues}>
        <TextInput source="summary" type="text" label="Summary" variant="outlined" />
        <TextInput source="text" type="text" label="Main text" variant="outlined" multiline />
      </SimpleForm>
    </Create>
  )};